module.exports = __webpack_public_path__ + "static/img/North-Melbourne.d970e63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/North-Melbourne.jpg
// module id = qlci
// module chunks = 1